/**
 * @generated SignedSource<<d133e7d7d72fd6dbae5b45c45ac3fa9d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "extsource"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "exttransactionid"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mode"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "transactiontype"
},
v8 = [
  {
    "kind": "Variable",
    "name": "endTs",
    "variableName": "endDate"
  },
  {
    "kind": "Variable",
    "name": "extsource",
    "variableName": "extsource"
  },
  {
    "kind": "Variable",
    "name": "exttransactionid",
    "variableName": "exttransactionid"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "mode",
    "variableName": "mode"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  },
  {
    "kind": "Variable",
    "name": "startTs",
    "variableName": "startDate"
  },
  {
    "kind": "Variable",
    "name": "transactiontype",
    "variableName": "transactiontype"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "transactionId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "transactionType",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "transactionTime",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "extSource",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "extTransactionId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TransactionsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": "TransactionTsConnection",
        "kind": "LinkedField",
        "name": "lookuptransactions",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionT",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "TransactionsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": "TransactionTsConnection",
        "kind": "LinkedField",
        "name": "lookuptransactions",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionT",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "024cf3e4e08a1292e0ecc8d34421fe71",
    "id": null,
    "metadata": {},
    "name": "TransactionsQuery",
    "operationKind": "query",
    "text": "query TransactionsQuery(\n  $extsource: String\n  $exttransactionid: String\n  $mode: Int\n  $transactiontype: Int\n  $startDate: Datetime\n  $endDate: Datetime\n  $first: Int\n  $offset: Int\n) {\n  lookuptransactions(extsource: $extsource, exttransactionid: $exttransactionid, mode: $mode, transactiontype: $transactiontype, startTs: $startDate, endTs: $endDate, first: $first, offset: $offset) {\n    totalCount\n    nodes {\n      transactionId\n      transactionType\n      transactionTime\n      description\n      extSource\n      extTransactionId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "d4bf290204af15e226015825abee2cc0";

module.exports = node;
